/* eslint-disable react/jsx-closing-tag-location */
import React from 'react';
import PropTypes from 'prop-types';
import withModalStateHandlers from '@sparefoot/react-core/decorators/withModalStateHandlers';

import { Button } from 'components/core/Button';
import { Modal, ModalBody, ModalTitle } from 'components/core/Modal';
import { H3, H4, Paragraph } from 'components/core/Typography';
import './AmazonModal.scss';

export const enhance = withModalStateHandlers;

export function AmazonModal({ modalShowing, onShowModal, onCloseModal }) {
	return (
		<div className="amazon-modal">
			<Button
				link
				secondary
				onClick={onShowModal}
				className="amazon-modal-button"
			>
				Eligibility details.
			</Button>
			<Modal
				className="amazon-modal"
				showing={modalShowing}
				onClose={onCloseModal}
			>
				<ModalTitle>
					<H3 last>Renter Reviews: Amazon Gift Card Drawing</H3>
				</ModalTitle>
				<ModalBody>
					<div className="information-section">
						<H4 size="small">Terms & Conditions</H4>
						<Paragraph last>
							On the first business day of every month, we
							randomly select one storage customer who left a
							review on SpareFoot during the previous month. We
							email this customer at the address provided with
							their review, letting them know they have won our
							drawing for a $250 Amazon gift card. Our email
							states that the customer has 7 days to reply and
							verify their preferred email address for electronic
							delivery of the gift card. If they reply in time,
							the customer will receive a $250 Amazon gift card,
							delivered electronically to their preferred email
							address within 1 business day. If the customer does
							not reply in time, we go back and randomly select a
							different storage customer, and this process repeats
							until we have a verified winner.
						</Paragraph>
					</div>
					<div className="information-section">
						<H4 size="small">Eligibility</H4>
						<Paragraph last>
							Every customer who submits a storage review with
							valid email address will be automatically entered
							into the Renter Reviews: Amazon Gift Card Drawing.
							Eligibility is dependent on your providing a valid
							email address in the review submission form of this
							page.
						</Paragraph>
					</div>
				</ModalBody>
			</Modal>
		</div>
	);
}

AmazonModal.propTypes = {
	modalShowing: PropTypes.bool.isRequired,
	onShowModal: PropTypes.func.isRequired,
	onCloseModal: PropTypes.func.isRequired,
};

export default enhance(AmazonModal);
